import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Strips trailing slashes from URLs to prevent duplicate-content indexing.
 * E.g. /pricing/ → /pricing
 */
export default function TrailingSlashRedirect(): null {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname !== "/" && pathname.endsWith("/")) {
      navigate(pathname.slice(0, -1) + search + hash, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  return null;
}
